import { formatMaterialDimensions, FormatterMaterialParameter, PartTypeType } from "shared";

type PartDimensions = FormatterMaterialParameter & { type: PartTypeType | null };

export const formatPartDimensions = ({
  type,
  height,
  width,
  length,
  tubeThickness,
}: PartDimensions) => formatMaterialDimensions(type, { height, width, length, tubeThickness });
